module.exports = __webpack_public_path__ + "static/media/T8-Microsoft__SQL__Server.381ebf2c.svg";